import React from 'react';
import HeaderTwo from '../common/header/HeaderTwo';
import HeroTwo from "../components/hero/HeroTwo";
import AboutTwo from "../components/about/AboutTwo";
import WhyChooseTwo from "../components/why-choose-us/WhyChooseTwo";
import FeatureTwo from "../components/features/FeatureTwo";
import BenefitsOne from "../components/benefits/BenefitsOne";
import AppointmentOne from "../components/appointment/AppointmentOne";
import ServiceTwo from "../components/services/ServiceTwo";
import ProjectTwo from "../components/project/ProjectTwo";
import TeamOne from "../components/team/TeamOne";
import TestimonialTwo from '../components/testimonial/TestimonialTwo';
import BlogTwo from "../components/blog/BlogTwo";
import BrandOne from "../components/brand/BrandOne";
import FooterOne from "../common/footer/FooterOne";

const HomeTwo = () => {
    return (
        <>
            <HeaderTwo />
            <HeroTwo />
            <AboutTwo />
            <WhyChooseTwo />
            <FeatureTwo />
            <BenefitsOne />
            <AppointmentOne />
            <ServiceTwo />
            <ProjectTwo />
            <TeamOne />
            <TestimonialTwo />
            <BlogTwo />
            <BrandOne />
            <FooterOne />
        </>
    )
}

export default HomeTwo;